import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../../contexts/ThemeContext';
import { useSupplyDeliveries } from '../../supplies/supply-deliveries/useData';
import { computeSupplyDeliveryLinesStatus } from '../../supplies/supply-deliveries/deliveryLineIssues';

const ScmsDeliveryLineStatus: React.FC<{ embedded?: boolean }> = ({ embedded }) => {
  const navigate = useNavigate();
  const { colors } = useTheme();
  const { data, isLoading } = useSupplyDeliveries(undefined, 1, 200);

  const totals = { complete: 0, partial: 0, pending: 0, no_lines: 0 };
  for (const d of data ?? []) {
    const status = computeSupplyDeliveryLinesStatus(d.lines);
    totals[status] += 1;
  }
  const all = totals.complete + totals.partial + totals.pending + totals.no_lines;
  const rows = [
    { key: 'complete', label: 'Complete', value: totals.complete, color: 'bg-emerald-500' },
    { key: 'partial', label: 'Partial', value: totals.partial, color: 'bg-amber-500' },
    { key: 'pending', label: 'Outstanding', value: totals.pending, color: 'bg-rose-500' },
    { key: 'no_lines', label: 'No lines', value: totals.no_lines, color: 'bg-slate-400' },
  ];

  const cardClass = embedded
    ? 'min-w-0 flex-1 flex flex-col min-h-0'
    : `${colors.surface} rounded-xl shadow-sm p-5 ${colors.border} border`;

  return (
    <div className={cardClass}>
      <div className="flex items-center justify-between mb-4">
        <h2 className={`text-base font-semibold ${colors.text}`}>Supplies · Delivery Line Status</h2>
        <button
          type="button"
          onClick={() => navigate('/supplies/supply-deliveries')}
          className={`text-sm ${colors.primaryFg} hover:opacity-80`}
        >
          View All
        </button>
      </div>
      {isLoading ? (
        <div className={`h-24 rounded-lg ${colors.surfaceHover} animate-pulse`} />
      ) : (
        <div className="space-y-2">
          {rows.map((row) => {
            const pct = all > 0 ? (row.value / all) * 100 : 0;
            return (
              <div key={row.key}>
                <div className="mb-1 flex items-center justify-between text-xs">
                  <span className={colors.textMuted}>{row.label}</span>
                  <span className={colors.text}>{row.value}</span>
                </div>
                <div className="h-2 w-full rounded bg-slate-200 dark:bg-slate-700">
                  <div className={`h-2 rounded ${row.color}`} style={{ width: `${pct}%` }} />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ScmsDeliveryLineStatus;
